var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-save-2209758",
    transform: "translate(-123.597 -124.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248036",
    "data-name": "\\u8DEF\\u5F84 248036",
    d: "M143.6,772.19v4.146a.889.889,0,0,1-.031.23.937.937,0,0,1-.926.714H124.548a.927.927,0,0,1-.938-.79.653.653,0,0,1-.013-.159v-4.146a.919.919,0,0,1,.945-.885.981.981,0,0,1,.668.26.861.861,0,0,1,.277.625V775.5h16.228v-3.321a.919.919,0,0,1,.945-.885.982.982,0,0,1,.668.26.9.9,0,0,1,.271.631Z",
    transform: "translate(0 -632.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248037",
    "data-name": "\\u8DEF\\u5F84 248037",
    d: "M337.229,133.957l-4.857,4.347c-.007.012-.02.018-.026.024a1.2,1.2,0,0,1-.639.289c-.02,0-.04.006-.059.006a.8.8,0,0,1-.119.006l-.112-.006c-.02,0-.04-.006-.059-.006a1.177,1.177,0,0,1-.639-.289l-.026-.024-4.857-4.347a.964.964,0,0,1,0-1.463,1.26,1.26,0,0,1,1.634,0l2.919,2.613v-9.573a1.1,1.1,0,0,1,1.153-1.032,1.253,1.253,0,0,1,.817.3.969.969,0,0,1,.336.731v9.573l2.919-2.613a1.26,1.26,0,0,1,1.634,0,.978.978,0,0,1-.02,1.463Z",
    transform: "translate(-197.931)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.68a358ee5e529d3c74127f22c6792c60.svg";
export { ForwardRef as ReactComponent };